import { render, staticRenderFns } from "./PhoTextField.vue?vue&type=template&id=6db1e183&lang=pug"
import script from "./PhoTextField.vue?vue&type=script&lang=js"
export * from "./PhoTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports